import { createLogic } from 'redux-logic'
import * as constants from '../constants'
import { map, mergeMap, take } from 'rxjs/operators'

export const getPropertyInfo = createLogic({
  type: constants.GET_PROPERTY_INFO.ACTION,
  processOptions: {
    successType: constants.GET_PROPERTY_INFO.FULFILLED,
    failType: constants.GET_PROPERTY_INFO.REJECTED
  },
  process({ http, action }) {
    const payload = { index: 'propertysearch', q: `omniViewPropertyId: ${action.payload.omniViewPropertyId}` }

    return http
      .post('/api/common/search/rawQuery', { ...payload })
      .pipe(
        map(http.getBody),
        map(response => response),
        mergeMap(response => {
          const listInfo = response?.data?.[0]
          const propertyIdList = listInfo?.omniViewPropertyId ? [listInfo?.omniViewPropertyId] : []

          return http.post('/comps/photos/query', { propertyIdList }).pipe(
            take(1),
            map(http.getBody),
            map(res => {
              if (res && response?.data?.[0]) {
                response.data[0].signedUrl = res[0]?.signedUrl
              }

              return {
                data: response?.data
              }
            }),
          )
        })
      )
    }
})
